import { GenericLazyString } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import IconButton from '../../iconButton/IconButton';
import ArrowLeftChunky from '../../iconography/icons/ArrowLeftChunky';
import { useTheme } from '../../theme-context';
import UnitsAvailable from '../basic/units-available';

interface IManageDashboardHeaderParams {
    backAction: () => void;
    eventInfo: {
        total: number;
        available: number;
        title: string;
        datetime: GenericLazyString;
    };
}

const ManageDashboardHeader = ({
    backAction,
    eventInfo,
}: IManageDashboardHeaderParams) => {
    const { total, available, title, datetime } = eventInfo;
    const { getFont, styles } = useTheme();

    return (
        <div
            className={css({
                position: 'initial',
                width: '100%',
                fontFamily: getFont('desktop/body/large').fontFamily,
                display: 'grid',
                gridTemplateColumns: 'fit-content(100%) auto fit-content(100%)',
                justifyItems: 'end',
                alignContent: 'space-between',
                alignItems: 'center',
                backgroundColor: styles.colors['brand-white'].color,
            })}
        >
            <div
                data-testid="back-button"
                className={css({
                    width: ' auto',
                    justifySelf: 'baseline',
                    marginLeft: '24px',
                })}
            >
                <IconButton
                    title="back button"
                    iconType={
                        <ArrowLeftChunky
                            fill={styles.colors['ui-blue'].color}
                        />
                    }
                    onClick={backAction}
                />
            </div>
            <div
                className={css({
                    justifySelf: 'baseline',
                    margin: '16px 28px 16px 16px',
                })}
            >
                <div
                    data-testid="event-title"
                    className={css({
                        fontWeight: getFont('desktop/body/large').fontWeight,
                        fontSize: getFont('desktop/body/large').fontSize,
                        lineHeight: '24px',
                    })}
                >
                    {title}
                </div>
                <div
                    data-testid="event-datetime"
                    className={css({
                        fontWeight: getFont('desktop/body/medium').fontWeight,
                        fontSize: getFont('desktop/body/medium').fontSize,
                        color: styles.colors['grey-05'].color,
                        lineHeight: '20px',
                    })}
                >
                    {datetime}
                </div>
            </div>
            <div
                data-testid="progress"
                className={css({
                    justifySelf: 'self-end',
                    marginRight: '28px',
                })}
            >
                <UnitsAvailable total={total} available={available} />
            </div>
        </div>
    );
};

export default ManageDashboardHeader;
